'use client';

import type { User } from 'oidc-client-ts';
import type React from 'react';
import { useEffect, useState } from 'react';
import { getUserManager } from '../../lib/oidcClient';
import { AuthContext } from './auth-context';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [userManager, setUserManager] = useState<ReturnType<typeof getUserManager> | null>(null);

    useEffect(() => {
        const manager = getUserManager();
        setUserManager(manager);

        manager
            .getUser()
            .then((user) => {
                setUser(user);
                if (user) {
                    manager.signinSilent().finally(() => {
                        setLoading(false);
                    });
                } else {
                    setLoading(false);
                }
            })
            .catch((_error) => {
                setLoading(false);
            });
    }, []);

    if (!userManager) return null;

    const signin = () => userManager.signinRedirect();
    const signout = () =>
        userManager.signoutRedirect({
            extraQueryParams: {
                client_id: userManager.settings.client_id,
                logout_uri: process.env.NEXT_PUBLIC_OIDC_POST_LOGOUT_URI as string,
            },
        });

    return <AuthContext.Provider value={{ user, loading, signin, signout }}>{children}</AuthContext.Provider>;
};
